var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#NoResults_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M66.61 43.915c1.047 1.053 2.064 2.147 3.157 3.153.71.655.72 1.088 0 1.778-4.64 4.446-9.918 7.897-15.94 10.073-15.376 5.563-29.997 3.896-43.734-4.99-2.278-1.474-4.255-3.427-6.377-5.141-.668-.544-.692-.977-.046-1.603a447 447 0 0 0 6.627-6.669c.581-.585.982-.66 1.633-.04 4.71 4.445 10.185 7.522 16.499 8.903 12.114 2.655 22.956-.053 32.391-8.202 1.64-1.415 1.616-1.439 3.134.077l2.65 2.667z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "NoResults_svg__b",
    width: 126,
    height: 69,
    x: -29,
    y: -6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M36.687 62.17c-15.043 0-26.223-7.318-29.272-10.164L-28.3 21.895 36.687-5.4l59.332 24-29.247 33c-9.96 8.537-24.19 10.57-30.085 10.57"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoResults_svg__b)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F45149",
    d: "M11.505 12.02a.42.42 0 0 0 .029.473l6.23 8.657a.436.436 0 0 0 .68.03l2.22-2.509 2.382 1.079a.4.4 0 0 0 .37-.009.4.4 0 0 0 .125-.092.43.43 0 0 0 .116-.236.43.43 0 0 0-.04-.26l-1.057-2.142-8.518-3.884 9.37 2.44 1.934-2.193q.186-.196.078-.459a.41.41 0 0 0-.376-.266l-13.13-.85a.428.428 0 0 0-.413.22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "m26.12 31.98-12.6-2.1s3 6.9 1.8 8.7l13.2 1.5c.6-2.1-2.4-8.1-2.4-8.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M15.5 38.4h33v26.4h-33z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC4CF",
    d: "M47.147 50.222 48.8 38.1l-3.3 8.1-30-.3v4.2l30.412 1.158a1.2 1.2 0 0 0 1.235-1.037",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M48.32 64.38v-26.4l12.6-2.1v22.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "m60.8 36-12.6 2.1s2.7-7.2 1.5-9l13.2-1.5c.6 2.1-2.1 8.4-2.1 8.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCE1E9",
    d: "m48.8 37.98-33.3.3-2.027 8.109a1.2 1.2 0 0 0 1.164 1.49h30.559c.535 0 1.005-.351 1.15-.866.519-1.828 1.732-6.144 2.454-9.033"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0059F6",
    d: "m57.862 44.873-5.673 1.324a1.686 1.686 0 1 1-.733-3.291l5.698-1.21a1.627 1.627 0 0 1 .708 3.177"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "NoResults_svg__c",
    width: 48,
    height: 35,
    x: 13,
    y: 30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F9",
    d: "M14.686 32.978c-.446-1.356.693-2.788 2.1-2.553l8.43 1.404a1.73 1.73 0 0 1 1.296.976c.56 1.213 1.556 3.53 1.934 5.358l19.874-.179v-.004l12.6-2.1v22.5l-12.6 6v.3h-33v-16.8H13.1l2.22-8.878v-.722h.146c.404-1.138-.158-3.408-.78-5.302"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoResults_svg__c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.3,
    cy: 35.7,
    fill: "#B9C2D1",
    opacity: 0.2,
    rx: 26.4,
    ry: 26.7,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.308,
    d: "M39.608 29.776s-5.872-5-10.841-4.109c-4.97.891.658 6.901 3.472 3.872s2.518-9.546-7.138-11.124"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.312,
    d: "m45.132 31.372 2.637-9.244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NoResults_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h72v72H.5z"
  })))));
};
export default SvgNoResults;